import { AppConfigModel } from "../abstract/app-config.model";

export class InvoiceType extends AppConfigModel {

    static override CLASS_NAME: string = 'InvoiceType';
}
